import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.API_DOMAIN
});

export const setAuthToken = token => {
  console.log('axios::setAuthToken', token); // eslint-disable-line no-console
  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const removeAuthToken = () => {
  delete instance.defaults.headers.common.Authorization;
};

instance.interceptors.response.use(undefined, error => {
  const normalizedError = { status: 0, message: '', error };

  if (error.response) {
    normalizedError.status = error.response.status;
    normalizedError.message =
      error.response.data?.message ||
      error.response.statusText ||
      'Unrecognized server error';
  } else if (error.request) {
    normalizedError.message = 'No response from server';
  } else {
    normalizedError.message = error.message || 'Request setup failed';
  }

  return Promise.reject(normalizedError);
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.put['Content-Type'] = 'application/json';
instance.defaults.headers.common['Accept'] = 'application/json'; // eslint-disable-line
export default instance;
